const FileExtensionRegex = /\.[a-zA-Z\d]+$/;

export const getFileNameExtension = (filename) => {
  return filename.match(FileExtensionRegex)[0].substring(1);
};
